import React from 'react';
import { CodeOutlined, CustomerServiceOutlined, DeleteTwoTone } from '@ant-design/icons';
import { Col, Form, List, Row } from 'antd-v6';
import PropTypes from 'prop-types';

const ListCommands = ({ commandTargetKeys, removeCommand, getCommandtypeName }) => {
	return (
		<Row>
			<Col span={24}>
				<Form.Item name="commadsList">
					<List
						className="commandFormRow commandList"
						dataSource={commandTargetKeys}
						renderItem={(item) => (
							<List.Item
								key={item.key}
								actions={[
									<DeleteTwoTone
										data-testid="btn-deleteCommand"
										key={1}
										onClick={() => removeCommand(item.key)}
									/>,
								]}
							>
								<List.Item.Meta
									avatar={item.isCustomerSupport ? <CustomerServiceOutlined /> : <CodeOutlined />}
									title={getCommandtypeName(item.commandTypeId)}
									description={item.text}
								/>
							</List.Item>
						)}
					/>
				</Form.Item>
			</Col>
		</Row>
	);
};

ListCommands.propTypes = {
	removeCommand: PropTypes.func.isRequired,
	getCommandtypeName: PropTypes.func.isRequired,
	commandTargetKeys: PropTypes.array.isRequired,
};

export default ListCommands;
